let APP_CONFIG = {}
let MOBILE_APP = false
let HOST_BRAND = null

const init = (mobileApp, hostBrand, app_config) => {
  MOBILE_APP = mobileApp
  HOST_BRAND = hostBrand
  APP_CONFIG = app_config
}

const appConfig = () => APP_CONFIG;
const mobileApp = () => MOBILE_APP;
const hostBrand = () => HOST_BRAND;

export default {
  init,
  appConfig,
  mobileApp,
  hostBrand
}
